
export const _TEST_URL = "https://sggfaatymqdxaedhleqq2b4h2q0zxupf.lambda-url.us-east-2.on.aws/";
export const PROD_URL = "https://lqjb7n2tnlb3xzkqxc5fawevw40ovtwm.lambda-url.us-east-2.on.aws/";
export const BASE_URL = "https://defindle.vercel.app";
export const CUSTOM_WORD_URL = "https://rmhpea26ctgdnukf36h7gs25km0kwkip.lambda-url.us-east-2.on.aws/";
export const GENERATE_TOKEN_URL = "https://qciaizgm24yrsihuu7h22sq45a0lxudw.lambda-url.us-east-2.on.aws/";
export const CHECK_TOKEN_URL = "https://cnvdknghetclozvm4cakksguua0xaqhy.lambda-url.us-east-2.on.aws/";
export const GET_STATS_URL = "https://neevprenrxzzucxzrozm4w7w540valkg.lambda-url.us-east-2.on.aws/";
export const UPDATE_STATS_URL = "https://lo47627m526jcp6ygk536yps2m0vqwvd.lambda-url.us-east-2.on.aws/";
export const MAX_GUESSES = 6;